import { useApi } from '@core/api'
import { InternalCreateCustomerInput, InternalUpdateCustomerInput } from '@core/api/generated'
import { addSnack } from '@core/snack/snack-state'
import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'

export const keys = {
  getCustomer: ['admin', 'getCustomer'],
  updateCustomer: ['admin', 'updateCustomer'],
  createCustomer: ['admin', 'createCustomer'],
}

export const useCustomer = () => {
  const api = useApi()

  return useSuspenseQuery({
    queryKey: keys.getCustomer,
    queryFn: async () => {
      const { data } = await api.internalGetCustomer({ throwOnError: true })

      return data
    },
  })
}

export const useUpdateCustomer = () => {
  const api = useApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: keys.updateCustomer,
    mutationFn: async (body: InternalUpdateCustomerInput) => {
      const { data } = await api.internalUpdateCustomer({
        body,
        throwOnError: true,
      })

      await queryClient.invalidateQueries({
        queryKey: keys.getCustomer,
      })

      return data
    },
    onSuccess: () => {
      addSnack({ message: 'Customer updated', severity: 'success' })
    },
    onError: (error: Error) => {
      addSnack({ message: error.message, severity: 'error' })
    },
  })
}

export const useCreateCustomer = () => {
  const api = useApi()

  return useMutation({
    mutationKey: keys.createCustomer,
    mutationFn: (body: InternalCreateCustomerInput) => {
      return api.internalCreateCustomer({ body })
    },
  })
}
